import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	header: {
		id: 'UserSeg.twc.workOnFrist.header',
		defaultMessage: 'What do you want to work on first?',
	},
	subHeaderV2: {
		id: 'UserSeg.twc.workOnFrist.subHeaderV2',
		defaultMessage: "We'll turn your ideas into organized, trackable work across apps.",
	},
	nextButton: {
		id: 'UserSeg.twc.workOnFrist.nextButton',
		defaultMessage: 'Next',
	},
	projectTracker: {
		id: 'UserSeg.twc.workOnFrist.workType.projectTracker',
		defaultMessage: 'Project tracker',
	},
	doc: {
		id: 'UserSeg.twc.workOnFrist.workType.doc',
		defaultMessage: 'Doc',
	},
	whiteboard: {
		id: 'UserSeg.twc.workOnFrist.workType.whiteboard',
		defaultMessage: 'Whiteboard',
	},
	projectTrackerIllustration: {
		id: 'UserSeg.twc.workOnFrist.image.projectTracker',
		defaultMessage: 'Project tracker illustration',
	},
	docIllustration: {
		id: 'UserSeg.twc.workOnFrist.image.doc',
		defaultMessage: 'Doc illustration',
	},
	whiteboardIllustration: {
		id: 'UserSeg.twc.workOnFrist.image.whiteboard',
		defaultMessage: 'Whiteboard illustration',
	},
});
